import { ErrorMessage } from "@hookform/error-message";
import { useFormContext } from "react-hook-form";
import ErrorLabel from "./errorLabel.tsx";

type Props = {
  name: string;
  label: string;
};

export default function Checkbox({ name, label }: Props) {
  const { register } = useFormContext();

  return (
    <div className="sm:col-span-4">
      <label
        htmlFor={name}
        className="block text-sm font-medium leading-6 text-gray-900"
      >
        {label}
      </label>
      <div className="mt-1">
        <input
          id={name}
          type="checkbox"
          className="h-4 w-4 rounded border-gray-300 text-sky-600 focus:ring-sky-600"
          {...register(name)}
        />
      </div>
      <ErrorMessage
        name={name}
        render={({ message }) => <ErrorLabel message={message} />}
      />
    </div>
  );
}
